var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.extraClass} notification message ${_vm.type}`},[_c('p',{staticClass:"icon"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }